// Packages
import { Component } from "react";
import { Link, withRouter } from "react-router-dom";
// Views
import Header from "./header";
// Assets
import FormikTextField from "../../Common/FormFields/FormikInputField";
import { Form, Formik } from "formik";
import contendZONEBlack from "../../assets/images/contendZONEViolet.png";
// Services
import userService from "../../services/user.service";
//Utils
import { getQueryparams } from "../../utils";
import { emailAddress } from "../../common";
import { openSuccessPopup } from "../../Redux/Actions/PopupActions";
import { connect } from "react-redux";
import validationSchema from "../../Validation/ValidationSchemas";
import { openFailDialog } from "../../Redux/Actions/PopupActions";
class SetPassword extends Component {
  constructor() {
    super();
    this.state = {
      errors: {},
      token: "",
      password: "",
      confirmPassword: "",
      type: "password",
      type1: "password",
    };

    this.submitPassword = this.submitPassword.bind(this);
  }

  componentDidMount() {
    const {
      location: { search },
    } = this.props;
    this.token = getQueryparams(search, "token");
  }

  submitPassword(values, setSubmitting) {
    setSubmitting(true);
    const { setFailPopUpInformation, setSuccessPopupInformation } = this.props;
    const { password, confirmPassword } = values;
    userService
      .setResetPassword(this.token, password, confirmPassword)
      .then((response) => {
        setSuccessPopupInformation({
          successPopUp: {
            message: "Password Reset Successfully",
            open: true,
            navigationLink: "/login",
          },
        });
      })
      .catch((error) => {
        setFailPopUpInformation({
          open: true,
          message: "Something Went Wrong",
        });
      });
    setSubmitting(false);
  }

  handleClick = () =>
    this.setState(({ type }) => ({
      type: type === "text" ? "password" : "text",
    }));
  handleClickconpass = () =>
    this.setState(({ type1 }) => ({
      type1: type1 === "text" ? "password" : "text",
    }));
  handleKeyPress = (event) => {
    if (event.key === "Enter") {
      this.submituserRegistrationForm();
    }
  };
  passwordHandled(e) {
    this.setState({
      password: e.target.value,
      confirmPassword: e.target.value,
    });
  }

  render() {
    return (
      <div>
        <div className="dnone">
          <Header></Header>
        </div>
        <section className="contact-section height-100vh d-flex flex-direction-c justify-sp-btn">
          <div className="row">
            <div className="col-12 col-sm-12 col-md-5 col-lg-5 mx-auto">
              <div className="text-center">
                <Link to="/">
                  <img
                    src={contendZONEBlack}
                    alt="logo"
                    className="logostyle ml-3 img-fluid mobilehide cp"
                    data-toggle="dropdown"
                    to="/home"
                  />
                </Link>
              </div>
              <div className="login-box mt-5">
                <div className="clear20"></div>
                <h6 className="fs-24 medium black text-center">
                  Set your own Password
                </h6>
                <div className="clear10"></div>
                <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                  <Formik
                    initialValues={{
                      password: "",
                      confirmPassword: "",
                    }}
                    validationSchema={validationSchema.forgotPasswordSchema}
                    onSubmit={(values, { setSubmitting }) =>
                      this.submitPassword(values, setSubmitting)
                    }
                  >
                    {(formik) => (
                      <Form className="form-container">
                        <FormikTextField
                          label="NEW PASSWORD"
                          formik={formik}
                          fieldName="password"
                          placeholder="Enter New Password"
                          labelFontSize="fs-18"
                          type="password"
                          customClassNames="formik-input-field instn fs-18 semi-bold w-100 olnone share-popup-input fmlabel black "
                        />
                        <FormikTextField
                          label="CONFIRM PASSWORD"
                          formik={formik}
                          fieldName="confirmPassword"
                          placeholder="Confirm New Password"
                          labelFontSize="fs-18"
                          type="password"
                          customClassNames="formik-input-field instn fs-18 semi-bold w-100 olnone share-popup-input fmlabel black "
                        />
                        <button
                          type="submit"
                          className="submit-btnblue fs-24 regular white w-100"
                          disabled={!formik.isValid}
                        >
                          {formik.isSubmitting
                            ? "Submitting..."
                            : "Create Password and Login"}
                        </button>
                      </Form>
                    )}
                  </Formik>
                  <div className="clear20"></div>
                </div>
              </div>
              <div className="clear20"></div>
              <div className="col-12 col-sm-12 col-md-12 col-lg-12 text-center"></div>
            </div>
          </div>
          <div className="clear10"></div>
          <div className="row">
            <div className="col-12 col-sm-12 col-md-6 col-lg-6">
              <h6 className="fs-16 medium notRegistered">
                `Copyright © {new Date().getFullYear()} - All rights reserved |
                CONTENDZONE | Disclaimer | Privacy Policy`
              </h6>
            </div>
            <div className="fs-16 medium txtblue col-12 col-sm-12 col-md-6 col-lg-6 text-right">
              <span className="fs-16 medium txtblue mr-5">{emailAddress}</span>
              <span className="black"></span>{" "}
            </div>
          </div>
        </section>
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    setSuccessPopupInformation: (obj) => openSuccessPopup(dispatch, obj),
    setFailPopUpInformation: (obj) => openFailDialog(dispatch, obj),
  };
};

const mapStateToProps = (state) => {
  return {
    userInfo: state.loggedUser,
  };
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(SetPassword)
);
